import React, { useEffect, useState } from "react";
import { TableRow, TableCell, Typography } from "@mui/material";
import { Warning } from "@mui/icons-material";
import { t } from "i18next";
import { DeliveryOrder } from "../../../model/delivery-order";
import { DeliveryOrderHeaderLine } from "./delivery-order-header-line";
import { DeliveryOrderListSubSort } from "./delivery-order-list-sub-sort";
import { DeliveryOrderContents } from "./delivery-order-contents";
import { SearchListModel } from "../../../../common/component/list/search-list/search-list-model";
import { DeliveryOrderDetail } from "../../../model/delivery-order-detail";
import { DeliveryOrderFilter } from "../../../model/delivery-order-filter";
import { FeatureToggle, IsFeatureToggleEnabled } from "../../../../helpers/is-feature-toggle-enabled";

interface IDeliveryOrderListLineProps {
    deliveryOrder: DeliveryOrder;
    searchListModel: SearchListModel<DeliveryOrder, DeliveryOrderDetail, DeliveryOrderFilter>;
    isExpanded: boolean;
    withSingleActionMenu: boolean;

    onSingleActionMenuClick: (anchor: EventTarget) => void;
    onParcellingPageOpen: () => void;
    onCancellationRequestMenuOpen: (anchor: HTMLElement) => void;
    onOrderIdQuickFilterEnabled: (value: number) => void;
}

export const DeliveryOrderListLine = (props: IDeliveryOrderListLineProps) => {
    const [isExpanded, setIsExpanded] = useState(props.isExpanded);

    useEffect(() => {
        setIsExpanded(props.isExpanded);
    }, [props.isExpanded]);

    const baseCols = 11 + (IsFeatureToggleEnabled(FeatureToggle.STOCKOUTS) ? 1 : 0);
    const totalCols = baseCols + props.searchListModel.additionalFields.length - 1;

    return (<>
        <DeliveryOrderHeaderLine key={`dor-${props.deliveryOrder.id}`}
                                 deliveryOrder={props.deliveryOrder}
                                 displaySingleActionPickerButton={props.withSingleActionMenu}
                                 isItemSelected={props.searchListModel.isSelected(props.deliveryOrder.id)}
                                 isExpanded={isExpanded}
                                 onExpandToggle={toggleValue => setIsExpanded(toggleValue)}
                                 additionalDataSize={props.searchListModel.additionalFields.length}
                                 onSelectionToggle={value => props.searchListModel.selectItem(props.deliveryOrder, value)}
                                 onSingleActionMenuClick={anchor => props.onSingleActionMenuClick(anchor)}
                                 onHeaderClick={() => props.onParcellingPageOpen()}
                                 onCancellationRequestMenuOpen={anchor => props.onCancellationRequestMenuOpen(anchor)} />
        {props.deliveryOrder.parcelConstraints && props.deliveryOrder.isLocker && (
            <TableRow className={"dod__locker-constraints"}>
                <TableCell className={"dod__locker-constraints-warning"}>
                    <Warning/>
                </TableCell>
                <TableCell colSpan={totalCols} >
                    <div className={"dod__locker-constraints-wrapper"}>
                        <Typography>
                                <strong>{t("components.deliveryOrderLine.lockerConstraintsTitle")}</strong>
                        </Typography>
                        <Typography>
                            {t("components.deliveryOrderLine.lockerConstraintsDetails", {
                                height: props.deliveryOrder.parcelConstraints.maxHeightInMm,
                                width: props.deliveryOrder.parcelConstraints.maxWidthInMm,
                                length: props.deliveryOrder.parcelConstraints.maxLengthInMm,
                                weight: props.deliveryOrder.parcelConstraints.maxWeightInGrams,
                            })}
                        </Typography>
                    </div>
                </TableCell>
            </TableRow>
        )}
        {isExpanded && <DeliveryOrderListSubSort searchListModel={props.searchListModel}
                                                 key={`dod-header-${props.deliveryOrder.id}`}
                                                 deliveryOrder={props.deliveryOrder} />}
        {isExpanded && <DeliveryOrderContents deliveryOrder={props.deliveryOrder}
                                              onOrderIdentifierFilterEnabled={orderId =>
                                                  props.onOrderIdQuickFilterEnabled(orderId)}
                                              additionalDataFields={props.searchListModel.additionalFields} />}
    </>);
};
